export const ADDRESS = 'Address_v1';
export const BILLING_ACCOUNT = 'BillingAccount_v3';
export const CUSTOMER = 'Customer_v1';
export const CUSTOMER_BILL = 'CustomerBill_v1';
export const GIGAMARKET_INFO = 'GigaMarketInfo_v2';
export const GIGAMARKET_SELL_QUALIFICATION = 'GigaMarketSellQualification_v1';
export const GIGAMARKET_TRANSACTIONS = 'GigaMarketTransactions_v1';
export const ID_CODE = 'IdCode_v2';
export const INSTALLED_BASIC_PRODUCTS = 'InstalledBasicProducts_v1';
export const INSTALLED_TARIFF_OPTION = 'InstalledTariffOption_v1';
export const LOYALTY_MANAGEMENT = 'LoyaltyManagement_v1';
export const MANAGE_USER_ACCOUNT = 'ManageUserAccount (SOAP)';
export const OFFER_API = 'OfferAPI_v1 (OST)';
export const OUTAGE = 'Outage_v1';
export const PAYMENT_MANAGEMENT = 'PaymentManagement_v1';
export const PAYMENT_MANAGEMENT_V2 = 'PaymentManagement_v2';
export const PAYMENT_METHOD = 'PaymentMethod_v1';
export const PREPAID_BALANCE_RECHARGE = 'PrepaidBalanceRecharge_v1';
export const PRODUCT = 'Product_v1';
export const PRODUCT_OFFERING = 'ProductOffering_v1';
export const PRODUCT_ORDER_V1 = 'ProductOrder_v1';
export const PRODUCT_ORDER_V2 = 'ProductOrder_v2';
export const PROPERTIES = 'Properties_v1';
export const RESOURCE = 'Resource_v1';
export const RESOURCE_VALIDATION = 'ResourceValidation_v1';
export const SSO = 'SSO';
export const SUBSCRIPTION = 'Subscription_v1';
export const TROUBLE_TICKET = 'TroubleTicket_v1';
export const TROUBLE_TICKET_ATTACHMENT = 'TroubleTicketAttachment_v1';
export const TROUBLE_TICKET_UPDATE = 'TroubleTicketUpdate_v1';
export const USAGE_CONSUMPTION_NEW = 'UsageConsumption_v1 (new)';
export const USAGE_CONSUMPTION_OLD = 'UsageConsumption_v1 (old)';
export const USAGE_MANAGEMENT = 'UsageManagement_v1';
